import { sendGTMEvent } from "@next/third-parties/google";

import type { AccommodationReservationProvider } from "../../__generated__/gql/graphql";

import { getProviderTypeName } from "./helpers/reservation";
import { clearLeadTimeStorage, getLeadTime } from "./helpers/reservation-form";

/**
 * 予約変更完了イベントを送信
 *
 * @param provider - 予約プロバイダ
 * @param ticketMasterId - チケットマスター ID（StayTicket の場合）
 * @param platform - プラットフォーム
 */
export function sendReservationUpdatedEvent({
  provider,
  ticketMasterId,
  platform = "web",
}: {
  provider: Pick<AccommodationReservationProvider, "__typename">;
  ticketMasterId?: string | null;
  platform?: "web" | "app";
}) {
  const { sec: leadTime, bucket: leadTimeBucket } = getLeadTime();
  let providerInfo: { [key: string]: string } = {
    provider: getProviderTypeName(provider),
  };
  if (provider.__typename === "StayTicketAccommodationReservationProvider") {
    providerInfo = {
      ...providerInfo,
      ticket_master_id: ticketMasterId ?? "",
    };
  }
  sendGTMEvent({
    event: "reservation_updated",
    ...providerInfo,
    platform_context: platform,
    time_to_reservation: leadTime?.toString(),
    time_to_reservation_bucket: leadTimeBucket,
  });
  clearLeadTimeStorage();
}
